<div *ngIf="!isContractor() && data.length > 0" style="margin-top: 15px;">
  <mat-toolbar class="form-toolbar"
    fxShow.gt-sm fxHide.lt-md>
    <span class="form-action-title">
        Waitlist Applications
    </span>
  </mat-toolbar>
  <div fxHide.gt-sm fxShow.lt-md>
    <div>
      <div class="form-action-title">Waitlist Applications</div>
    </div>
    <mat-divider></mat-divider>
  </div>
  <div
    style="margin-top: 18px;">
    <mat-card>
      <div>
        <div [innerHTML]="textHomeownerDwellingQualified"></div>
      </div>
      <mat-list>
        <mat-list-item *ngFor="let dwelling of data">
          <mat-icon mat-list-icon>home</mat-icon>
          <div mat-line>{{dwelling.name}} </div>
          <div mat-line>{{dwelling.statusCodeOptionSet}} <a

                href="javascript:void(0)"
                (click)="onWithdrawEvent(dwelling.id)">
                Withdraw application
              </a></div>

        </mat-list-item>
      </mat-list>
    </mat-card>
  </div>
</div>
